import React, { useState, useEffect } from "react";

import Chart from "react-apexcharts";

import { useSelector } from "react-redux";

import axios from "axios";

const Statistic = () => {

     const user = useSelector((state) => state.user.data);
     
       const phone = user?.phone;
       const email = user?.email;
       const username = user?.username;
       const studid = user?.stud_id;

    const [report, setReport] = useState([]);

    const FetchReport = () => {
        axios({
          method: "post",
          url: "./v3/report/",
          data: {
            studid,
          },
          config: { headers: { "Content-Type": "multiport/form-data" } },
        })
          .then(function (response) {
            const view = response.data;

            setReport(view);
            
          })
          .catch((err) => {
            // toast.error("Error: Request Failed! Refresh page..");
          });
      };
    
      useEffect(() => {
        FetchReport();
      }, [studid]);

    const fail = 100 - report.pass;

    const pass = report.pass;

    const config = {
        series: [parseInt(pass), parseInt(fail)],
        options: {
            labels: ['Pass', 'Fail'],
            chart: {
                type: "donut",
                toolbar: {
                    show: false,
                },
            },
            legend: {
                show: false
            },
            fill: {
                colors: ['#706fd3', '#ff793f']
            },
            dataLabels: {
                enabled: false,
            },
            cutout: 100,
            cutoutPercentage: "100%",
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                animateScale: true,
                animateRotate: true,
            },
            tooltips: {
                enabled: true,
                intersect: false,
                mode: "nearest",
                bodySpacing: 5,
                yPadding: 10,
                xPadding: 10,
                caretPadding: 0,
                displayColors: false,
                cornerRadius: 4,
                footerSpacing: 0,
                titleSpacing: 0,
            },
            plugins: {
                legend: {
                    display: false,
                    show: true
                },
            },
            responsive: [
                {
                    series: [1],
                    breakpoint: 400,
                    options: {
                        labels: ['Empty'],
                        chart: {
                            width: 130,
                            height: 130,
                        },
                        legend: {
                            show: false
                        },
                    },
                },
            ],
        },
    };

    return (
        <div>
            <div className="">
                <Chart
                    options={config.options}
                    series={config.series}
                    type="donut"
                    height={250}
                />

            <div className='row align-items-center mt-3'>
                <div className='col-6'>
                    <div className='card bg-chart1 shadow-none py-4 text-center opacity-75' style={{ borderRadius: "25px" }}>
                        <div className='text-white fs-10 fw-medium'>
                           {report.pass}%
                        </div>
                    </div>
                </div>

                <div className='col-6'>
                    <div className='card bg-chart2 shadow-none py-4 text-center opacity-75' style={{ borderRadius: "25px" }}>
                        <div className='text-white fs-10 fw-medium'>
                           {100 - report.pass}%
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Statistic